import * as userRequest from "@/utils/userRequest";

export default async function getRankInterestAvailable(
  token: string,
  onSuccess?: (data?: any) => any,
  handleError?: (err?: any) => any
) {
  try {
    const res = await userRequest.get("interests/available", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("🚀 ~ getRankInterestAvailable ~ res:", res);
    if (res) {
      onSuccess && onSuccess(res);
      return res;
    }
  } catch (err) {
    console.error("🚀 ~ getRankInterestAvailable ~ err:", err);
    handleError && handleError(err);
    throw err;
  }
}
